import React from "react";
import {
    Grid,
    makeStyles, Typography,
} from "@material-ui/core";
import MainScreen from "./templates/MainScreen";
import { useTranslation } from "react-i18next";

import routes from "../../utils/routes.json";

import SentimentVeryDissatisfiedIcon from "@material-ui/icons/SentimentVeryDissatisfied";

const useStyles = makeStyles(() => ({
    centerHorizontal: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    center: {
        margin: "auto auto",
    },
    card: {
        backgroundColor: "#FFC801",
        height: "90%",
        width: "50vh",
        maxWidth: "90%",
        padding: "5px",
    },
    grid: {
        height: "100%",
    },
    textWrapper: {
        flex: "1 0 auto",
    },
    text: {
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "40% !important",
        width: "min-content",
    },
}));


export default function Page404(): JSX.Element {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <MainScreen lower={false} back={true} backPath={routes.menu}>
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                className={`${classes.grid}`}
            >
                <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                    className={`${classes.centerHorizontal} ${classes.card}`}
                >
                    <div className={`${classes.textWrapper}`}>
                        <Typography variant="h1" color="primary" className={`${classes.text} `}>
                            {t("404.message")}
                        </Typography>
                    </div>

                    <SentimentVeryDissatisfiedIcon />
                </Grid>
            </Grid>

        </MainScreen>

    );
}
